/* Created by: Murugeswari Chandrabose
   Created At: 22 Jan 2024
   Modified by :kani
   Description : Student list 
*/
// src/components/filter.
import React, { useEffect, useMemo, useState } from "react";
import PropTypes from 'prop-types';
import { Link, useNavigate } from "react-router-dom";
import * as Yup from "yup";
//import components
import Breadcrumbs from '../../../components/Common/Breadcrumb';
import TableContainer from '../../../components/Common/TableContainer';
import { ToastContainer } from "react-toastify";
import Spinners from "../../../components/Common/Spinner";
import { useFormik } from "formik";
import DeleteModal from "../../../components/Common/DeleteModal";
import Select from "react-select";
import { resetUserRoleStore, deleteUserrole } from "../../../store/actions";
import { getLoggedInUser } from "../../../helpers/fakebackend_helper"
import * as constants from "../../../constants/layout"
import axios from "axios";
import { useDispatch } from "react-redux";

import * as url from "../../../../src/helpers/url_helper";
//Import Flatepicker
import "flatpickr/dist/themes/material_blue.css";
import { Button, Col, Row, UncontrolledTooltip, Modal, ModalHeader, ModalBody, Form, Input, FormFeedback, Label, Card, CardBody, FormGroup, Badge } from "reactstrap";
import { set } from "lodash";

const StudentMaster = () => {
    document.title = "Masters | Student Master";

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [isLoading, setLoading] = useState(false);
    const user = getLoggedInUser()
    const [canView, setCanView] = useState(false)
    const [canCreate, setCanCreate] = useState(false)
    const [canModify, setCanModify] = useState(false)
    const [canRemove, setCanRemove] = useState(false)
    const [studentmasterlist, setstudentmasterlist] = useState([])
    const [studentdetails, setstudentdetails] = useState([])
    // const [details, setdetails] = useState([])
    // const [stuname, setstuname] = useState([])
    // const [status, setstatus] = useState([])
    // const [stu_mail, setstu_mail] = useState([])
    // const [stu_mobileno, setstu_mobileno] = useState([])
    // const [preferences, setpreferences] = useState("");
    // const [interested, setinterested] = useState("");
    // const [preferencevalue, setpreferencevalue] = useState("");
    // const [interestedvalue, setinterestedvalue] = useState("");
    const [username, setusername] = useState("");
    const [selectedStatus, setselectedStatus] = useState(null);
    const [optionStatus , setOptionStatus] = useState([]);
    const [totalCount, setTotalCount] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [current, setCurrent] = useState(0);
    const [selectedSubscriptionStatus, setSelectedSubscriptionStatus] = useState(null);
    const [optionSubscriptionStatus,setOptionSubscriptionStatus] = useState([]);
    const [optionTestAttempt,setOptionTestAttempt] = useState([]);
    const [selectedTestAttempt, setSelectedTestAttempt] = useState(null);
    const [ddDisable,setddDisable] = useState(false);
    const [ddDisable1,setddDisable1] = useState(false);
    const [dashboard,setDashboard]=useState([]);
    
    const perPageData = 2;
    const [filterData, setFilterData] = useState({
        selectedStatus: -1,
        selectedTopicName: 0,
        selectedSubscriptionStatus:0,
        selectedTestAttempt:0
    })
     
    let testAttemptValue = [
        {
            label: "Yes",
            id: "1"
        },
        {
            label: "No",
            id: "2"
        }];
    const validation = useFormik({
        enableReinitialize: true,
        initialValues: {
            status: true
        },
        validationSchema: Yup.object({
            userdisplayName: Yup.string().required("Please Enter User display Name"),
            loginID: Yup.string().required("Please Enter Login ID"),
            password: Yup.string().required("Please Enter Password"),
            confirmPassword: Yup.string()
                .oneOf([Yup.ref('password'), null], 'Passwords must match')
                .required('Please confirm your password'),
        }),
        onSubmit: (values) => {

            toggle();
        },
    });

    

    useEffect(() => {
        const authUser = JSON.parse(sessionStorage.getItem('SESSION_KEY'));
        if (authUser && authUser.u_name) {

            setusername(authUser.u_name.charAt(0).toUpperCase());
        }
        setselectedStatus({ label: "All", value: "-1"})
        setSelectedSubscriptionStatus({ label: "All", value: "0"});
        setSelectedTestAttempt({ label: "All", value: "0"});
        setOptionTestAttempt(testAttemptValue);
        getmasterapi();
        getStudentDashboard();
        
    }, []);


 const getmasterapi = async () => {
        const data = { user_id: Number(user.uid), approvel_list_flag: 1 }
        const config = { headers: { authorization: 'Bearer '.concat(user.accessToken) } }
        const response1 = await axios.post(url.BASE_URL + 'master/getMaster', data, config)

        if (response1?.data?.body?.status === '401' || response1?.data?.body?.status === 401) {
            const refresh = await getRefreshToken() // Calling refreshToken if accessToken Expired
            if (refresh) {
                if (Number(refresh) === constants.invalidRefreshToken) {
                    logoutUser()
                } else {
                    await getmasterapi() // calling same function again getting refresh token
                }
            }
        }

        if (response1 && response1.data && response1.data && response1.data.status === 200) {

            if (response1.data && response1?.data?.body?.student_status){
                            setOptionStatus(response1?.data?.body?.student_status)
            }
            if (response1.data && response1?.data?.body?.subscription_status){
                            setOptionSubscriptionStatus(response1?.data?.body?.subscription_status)
            }
            
        }
    }
    const getStudentDashboard = async () => {
        const data = { user_id: Number(user.uid) }
        const config = { headers: { authorization: 'Bearer '.concat(user.accessToken) } }
        const response1 = await axios.post(url.BASE_URL + 'student/getStudentDashboard', data, config)

        if (response1?.data?.body?.status === '401' || response1?.data?.body?.status === 401) {
            const refresh = await getRefreshToken() // Calling refreshToken if accessToken Expired
            if (refresh) {
                if (Number(refresh) === constants.invalidRefreshToken) {
                    logoutUser()
                } else {
                    await getStudentDashboard() // calling same function again getting refresh token
                }
            }
        }

        if (response1 && response1.data && response1.data && response1.data.status === 200) {
            setDashboard(response1?.data?.body)
        }
    }

     useEffect(() => {
    
        var page_indexOfLast = currentPage * perPageData;
        var offset = page_indexOfLast - perPageData;
        getstudentdetailslist(offset);
    
      }, [filterData, currentPage]);
      useEffect(() => {
        if (current) {
          getstudentdetailslist(current)
        }
        setCurrent(0)
      }, [current])


    async function getstudentdetailslist(offset) {
    setLoading(true);
    const user = getLoggedInUser()
    const data = {
      "user_id": Number(user.uid),
      "status": Number(filterData?.selectedStatus),
      "subscription_status": filterData?.selectedSubscriptionStatus ?  Number(filterData?.selectedSubscriptionStatus):0,
      "test_attempted":filterData?.selectedTestAttempt ?  Number(filterData?.selectedTestAttempt):0,
      "search_data": filterData?.selectedTopicName ? filterData?.selectedTopicName : "",
      "limit": 10,
      "offset": Number(current) != 0 ? Number(current - 1) : 0,
    }
    const config = { headers: { authorization: 'Bearer '.concat(user.accessToken) } }
    const response1 = await axios.post(url.BASE_URL + 'student/getStudentlist', data, config)
    if (response1 && response1.statusFlag === 3) { // user validation
      setLoading(false);
      toast.error(response1.message, { autoClose: 2000 });
      localStorage.removeItem("authUser");
      sessionStorage.removeItem("SESSION_KEY")
      window.location.reload()
      return
    }
    if (response1?.data?.body?.status === '401' || response1?.data?.body?.status === 401) {
      setLoading(false);
      const refresh = await getRefreshToken() // Calling refreshToken if accessToken Expired
      if (refresh) {
        if (Number(refresh) === constants.invalidRefreshToken) {
          logoutUser()
        } else {
          getstudentdetailslist(offset) // calling same function again getting refresh token
        }
      }
    }
    if (response1 && response1.data && response1.data.body) {
      setstudentmasterlist(response1.data.body.studentList)
      setTotalCount(response1.data.body.studentCount)
      setLoading(false);
      return { statusFlag: response1.data.body.statusFlag, message: response1.data.body.message }
    } else {
      setLoading(false);
      return { statusFlag: 2, message: 'Something went wrong' }
    }

  }
    const columns = useMemo(
        () => [
            {
                header: 'Actions',
                width: '8%',

                cell: (cellProps) => {
                    return (
                        <div className="d-flex gap-3">

                            {user && user.user_previleges && user.user_previleges.find(f =>
                                Number(f.urp_smid) === constants.SubmenuList.StudentMaster && f.urp_type === constants.menuTypes.Remove) && (
                                    <Link
                                        to={`/view-student/${cellProps.row.original.stid}`}
                                        className="btn btn-sm btn-soft-danger"
                                        // onClick={() => {
                                        //     const studentdetails = cellProps.row.original;
                                        //     onClickview(studentdetails);
                                        //     navigate(`/view-student/`)
                                        // }}
                                        >
                                        <i className="mdi mdi-eye" id="deletetooltip" />
                                        <UncontrolledTooltip placement="top" target="deletetooltip">
                                            View
                                        </UncontrolledTooltip>
                                    </Link>)}

                        </div>
                    );
                }
            },
            {
                header: 'S.No.',
                accessorKey: 'sno',
                width: '8%',
                enableColumnFilter: false,
                enableSorting: true,
                className: 'pl-25',
                cell: ({ row, table }) =>
                    (table.getSortedRowModel()?.flatRows?.findIndex((flatRow) => flatRow.id === row.id) || 0) + 1

            },
            {
                header: (
                    <span style={{ cursor: 'pointer' }}>
                        Student Name ▼
                    </span>
                ),

                accessorKey: 'st_name',
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: (
                    <span style={{ cursor: 'pointer' }}>
                        Email ID ▼
                    </span>
                ),

                accessorKey: 'st_email',
                enableColumnFilter: false,
                enableSorting: true,

            },
            {
                header: (
                    <span style={{ cursor: 'pointer' }}>
                        Status ▼
                    </span>
                ),

                accessorKey: 'st_stsid',
                enableColumnFilter: false,
                enableSorting: true,
                cell: (cellProps) => {
                    const st_stsid = cellProps.row.original.st_stsid;

                    let icon;
                    switch (st_stsid) {
                        case "1":
                            icon = <span>
                                <i className="mdi mdi-check-circle text-success me-2" id="activetooltip" style={{ fontSize: '25px' }} />
                                <UncontrolledTooltip placement="top" target="activetooltip">
                                    Active
                                </UncontrolledTooltip>
                            </span>
                            break;
                        case "2":
                            icon =
                                <span>

                                    <i className="dripicons dripicons-wrong text-danger me-2" id="inactivetooltip" style={{ fontSize: '20px' }} />
                                    <UncontrolledTooltip placement="top" target="inactivetooltip">
                                        InActive
                                    </UncontrolledTooltip>
                                </span>
                            break;
                        case "3":
                            icon =
                                <span>

                                    <i className="mdi mdi-book-clock-outline text-warning me-2" id="pendingtooltip" style={{ fontSize: '25px' }} />
                                    <UncontrolledTooltip placement="top" target="pendingtooltip">
                                        Pending
                                    </UncontrolledTooltip>
                                </span>
                            break;

                    }

                    return (
                        <div className="d-flex align-items-center">
                            {icon}
                        </div>
                    );
                },
            },
            {
                header: (
                    <span style={{ cursor: 'pointer' }}>
                        Created At ▼
                    </span>
                ),

                accessorKey: 'u_created',
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: (
                    <span style={{ cursor: 'pointer' }}>
                        Created By ▼
                    </span>
                ),

                accessorKey: 'u_createdby',
                enableColumnFilter: false,
                enableSorting: true,
            },
        ],
        []
    );





    //Initial List API calling
    useEffect(() => {
        document.getElementById('headerTitle').innerHTML = 'Student Master';
    }, []);
 function handleSelectStatus(varselectedStatus) {
    setselectedStatus(varselectedStatus);
    if(varselectedStatus.value == 0){
        setSelectedSubscriptionStatus({ label: "All", value: "0"});
        setSelectedTestAttempt({ label: "All", value: "0"});
        setddDisable(true);
        setddDisable1(true);

    }
    else{
       setddDisable(false);
       setddDisable1(false);
    }
  }
  function handleSelectSubscriptionStatus(varselectedSubscriptionStatus) {
         setSelectedSubscriptionStatus(varselectedSubscriptionStatus);
     if(varselectedSubscriptionStatus.value == 2){
        setSelectedTestAttempt({ label: "All", value: "0"});
        setddDisable1(true);
        setddDisable(false);
    }
    else{
        setddDisable1(false);
        setddDisable(false);
    }
      
  }
    //USer role credentials
    useEffect(() => {
        if (user && user.user_previleges) {
            let page_menu_list = user.user_previleges.filter(p => Number(p.urp_smid) === constants.SubmenuList.StudentMaster)
            if (page_menu_list) {
                setCanView(page_menu_list.find(f => f.urp_type === constants.menuTypes.View)?.urp_smid ? true : false)
                setCanCreate(page_menu_list.find(f => f.urp_type === constants.menuTypes.Create)?.urp_smid ? true : false)
                setCanModify(page_menu_list.find(f => f.urp_type === constants.menuTypes.Modify)?.urp_smid ? true : false)
                setCanRemove(page_menu_list.find(f => f.urp_type === constants.menuTypes.Remove)?.urp_smid ? true : false)
            }
        }
    }, [user]);

    return (
        <React.Fragment>
             {  isLoading?  <Spinners setLoading={setLoading} />:'' }
 
            <div className="page-content" style={{ height: '100%' }}>
                <div className="container-fluid">
                    {/* <Breadcrumbs title="Masters" breadcrumbItem="User Role" /> */}
                   <Row>
                             <Col md="2">
                           <Card className="mini-stats-wid">
                             <CardBody>
                               <div className="d-flex" >
                                 <div className="flex-grow-1">
                                   <p className="text-muted fw-medium mb-2">{'Total Students'}</p>
                                   <h4 className="mb-0">{dashboard?.totalStudent || 0}</h4>
                                 </div>
                                 <div className="mini-stat-icon avatar-sm align-self-center rounded-circle bg-primary">
                                   <span className="avatar-title">
                                     <i className={"bx bx-package font-size-24"} />
                                   </span>
                                 </div>
                               </div>
                             </CardBody>
                           </Card>
                         </Col>
                         <Col md="4">
                           <Card className="mini-stats-wid">
                             <CardBody>
                               <div className="d-flex" >
                                 <div className="flex-grow-1">
                                   <p className="text-muted fw-medium mb-2">{'Verified'}</p>
                                   <h4 className="mb-0">{dashboard?.verifiedStudent || 0}</h4>
                                 </div>
                                 <div className="flex-grow-1">
                                   <p className="text-muted fw-medium mb-2">{'Pending'}</p>
                                   <h4 className="mb-0">{dashboard?.pendingStudent || 0}</h4>
                                 </div>
                                 <div className="mini-stat-icon avatar-sm align-self-center rounded-circle bg-primary">
                                   <span className="avatar-title">
                                     <i className={"bx bx-badge-check font-size-24"} />
                                   </span>
                                 </div>
                               </div>
                             </CardBody>
                           </Card>
                         </Col>
                         <Col md="6">
                           <Card className="mini-stats-wid">
                             <CardBody>
                               <div className="d-flex">
                                 <div className="flex-grow-1">
                                   <p className="text-muted fw-medium mb-2">{'Subscribed'}</p>
                                   <h4 className="mb-0">{dashboard?.subscribed || 0}</h4>
                                 </div>
                                   <div className="flex-grow-1">
                                   <p className="text-muted fw-medium mb-2">{'Not yet Subscribed'}</p>
                                   <h4 className="mb-0">{dashboard?.notyetSubscribed || 0}</h4>
                                 </div>
                                   <div className="flex-grow-1">
                                   <p className="text-muted fw-medium mb-2">{'Expired'}</p>
                                   <h4 className="mb-0">{dashboard?.expired || 0}</h4>
                                 </div>
                                 <div className="mini-stat-icon avatar-sm align-self-center rounded-circle bg-primary">
                                   <span className="avatar-title">
                                     <i className={"mdi mdi-shield-star-outline font-size-24"} />
                                   </span>
                                 </div>
                               </div>
                             </CardBody>
                           </Card>
                         </Col>
                   </Row>
                    <Row>
                        {
                                <Col xs="12">
                                     <Form>
                                        <Card className="cardfirstheight">
                                            <CardBody>
                                                <Row>
                                                    <Col lg={2}>
                                                        <div>
                                                            <Label>Verification Status</Label>
                                                            <Select
                                                                    value={selectedStatus}
                                                                    onChange={(selectedOption) => {
                                                                        handleSelectStatus(selectedOption);
                                                                    }}
                                                                    options={optionStatus.map((option) => ({
                                                                            label: option.label,
                                                                            value: option.id,
                                                                    }))}
                                                                    className="select2-selection"
                                                                />
                                                            </div>
                                                        </Col>
                                                        <Col lg={2}>
                                                        <div>
                                                            <Label>Subscription Status</Label>
                                                            <Select
                                                                    value={selectedSubscriptionStatus}
                                                                    onChange={(selectedOption) => {
                                                                        handleSelectSubscriptionStatus(selectedOption);
                                                                    }}
                                                                    options={optionSubscriptionStatus.map((option) => ({
                                                                            label: option.label,
                                                                            value: option.id,
                                                                    }))}
                                                                    className="select2-selection"
                                                                    isDisabled={ddDisable}
                                                                />
                                                            </div>
                                                        </Col>
                                                         <Col lg={2}>
                                                        <div>
                                                            <Label>Test Attempt</Label>
                                                            <Select
                                                                    value={selectedTestAttempt}
                                                                    onChange={(selectedOption) => {
                                                                        setSelectedTestAttempt(selectedOption);
                                                                    }}
                                                                    options={optionTestAttempt.map((option) => ({
                                                                            label: option.label,
                                                                            value: option.id,
                                                                    }))}
                                                                    className="select2-selection"
                                                                     isDisabled={ddDisable1}
                                                                />
                                                            </div>
                                                        </Col>
                                                        <Col lg={6}>
                                                                    <div className="d-flex flex-wrap gap-2 justify-content-start">
                                                                      <Button
                                                                        type="button"
                                                                        style={{ marginTop: 25 }}
                                                                        className="btn btn-soft-info"
                                                                        onClick={() => {
                                                                            
                                                                          setFilterData({
                                                          
                                                                            selectedStatus: selectedStatus ? selectedStatus.value : -1,
                                                                            selectedSubscriptionStatus: selectedSubscriptionStatus ? selectedSubscriptionStatus.value : 0,
                                                                            selectedTestAttempt: selectedTestAttempt ? selectedTestAttempt.value : 0
                                                                          });
                                                                        }}
                                                                      >
                                                                        Apply
                                                                      </Button>
                                                                      <Button
                                                                        type="button"
                                                                        style={{ marginTop: 25 }}
                                                                        className="btn btn-soft-danger"
                                                                        onClick={() => {
                                                                            setddDisable(false);
                                                                            setddDisable1(false);
                                                                          setFilterData({
                                                                            selectedStatus: -1,
                                                                            selectedSubscriptionStatus: 0,
                                                                            selectedTestAttempt: 0
                                                                          });
                                                                          setselectedStatus({ label: "All", value: "-1" });
                                                                          setSelectedSubscriptionStatus({ label: "All", value: "0"});
                                                                          setSelectedTestAttempt({ label: "All", value: "0"});
                                                                         
                                                                        }}
                                                                      >
                                                                        Clear
                                                                      </Button>
                                                           
                                                            </div>
                                                          </Col>
                                                        </Row>
                                                      </CardBody>
                                                    </Card>
                                                  </Form>
                                        <Card>
                                        <CardBody>
                                           
                                            <br></br>
                                            <TableContainer
                                                columns={columns}
                                                data={studentmasterlist || []}
                                                isGlobalFilter={true}
                                                isPagination={true}

                                                buttonName="Add"
                                                SearchPlaceholder="Search..."
                                                pagination="pagination"



                                                buttonClass="btn btn-primary waves-effect waves-light mb-2 me-2 addOrder-modal"

                                                tableClass="align-middle table-nowrap dt-responsive nowrap w-100 table-check dataTable no-footer dtr-inline"
                                                theadClass="table-light"

                                                paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
                                            />
                                        </CardBody>
                                    </Card>
                                </Col>
                        }
                    </Row>
                    
                </div>
            </div>
            <ToastContainer />
        </React.Fragment>
    );
}
StudentMaster.propTypes = {
    preGlobalFilteredRows: PropTypes.any,

};


export default StudentMaster;